/**
 * NOTE: This file is a copy of the original file from the `react-bootstrap@v2.10.4` package. (Deleted unnecessary code)
 * TODO: Remove after migration to `react-bootstrap@v2`.
 *
 * @url https://github.com/react-bootstrap/react-bootstrap/blob/master/src/ThemeProvider.tsx
 */
import { createContext, useContext } from "react";
export * from "react-bootstrap/esm/ThemeProvider";

export const DEFAULT_BREAKPOINTS = ["xl", "lg", "md", "sm", "xs"];
export const DEFAULT_MIN_BREAKPOINT = "xs";

export interface ThemeContextValue {
	prefixes: Record<string, string>;
	breakpoints: string[];
	minBreakpoint?: string;
	dir?: string;
}

const ThemeContext = createContext<ThemeContextValue>({
	prefixes: {},
	breakpoints: DEFAULT_BREAKPOINTS,
	minBreakpoint: DEFAULT_MIN_BREAKPOINT,
});

export function useBootstrapBreakpoints() {
	const { breakpoints } = useContext(ThemeContext);
	return breakpoints;
}

export function useBootstrapMinBreakpoint() {
	const { minBreakpoint } = useContext(ThemeContext);
	return minBreakpoint;
}
